import SpotlightTrailerBannerV2 from './SpotlightTrailerBannerV2'

export default SpotlightTrailerBannerV2
// eslint-disable-next-line import/export
export * from './SpotlightTrailerBannerV2'
